type PersonName = {
  first_name?: string | null
  last_name?: string | null
}

export const normalizePersonSearchText = (searchText: string): string =>
  searchText.replace(/\s/g, '')

export const buildPersonSearchPatterns = (searchText: string) => {
  const nameParts = searchText.trim().split(/\s+/).filter(Boolean)

  return {
    combined: `%${nameParts.join('')}%`,
    singleField: `%${nameParts.join(' ')}%`,
    firstName: `%${nameParts[0] ?? ''}%`,
    lastName: `%${nameParts.slice(1).join(' ')}%`,
    hasLastName: nameParts.length > 1
  }
}

export const buildPersonSearchPattern = (searchText: string): string =>
  buildPersonSearchPatterns(searchText).combined

export const matchesPersonNameSearch = (person: PersonName, searchText: string): boolean => {
  const normalizedSearchText = normalizePersonSearchText(searchText).toLowerCase()

  if (!normalizedSearchText) {
    return true
  }

  const normalizedName = normalizePersonSearchText(
    [person.first_name, person.last_name].filter(Boolean).join(' ')
  ).toLowerCase()

  return normalizedName.includes(normalizedSearchText)
}
